import { ProfilePicture, ModalConfirm } from '@/components'
import { clearStorage } from '@/utils/storage'
import { BellOutlined, PlusCircleOutlined, UserOutlined, SettingOutlined, InboxOutlined, CustomerServiceOutlined, LogoutOutlined } from '@ant-design/icons'
import {
  Badge,
  Button,
  Form,
  Input,
  List,
  Menu,
  Popover,
  Select,
  Space,
  Typography,
} from 'antd'
import { Auth } from 'aws-amplify'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import './style.scss'
import { useEffect, useRef } from 'react'
import { APIS, getActivityLogs, updateCurrentUser } from '@/utils/apiEndpoints'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import constants from '@/utils/constants'
import { loadOrganizations } from '@/store/actions'
import common from '@/utils/common'
import moment from 'moment'
import { svgImage } from '@/assets/svg/svg-icon'

const NotificationList = ({ data, unreadCount, getLogs }) => {
  const history = useHistory()
  const markAsRead = async () => {
    try {
      await APIS.setActivityLogs({ markAsRead: true })
      getLogs()
    } catch (error) {
      
    }
  }
  const clearAll = async () => {
    try {
      await APIS.setActivityLogs({ clearAll: true })
      getLogs()
    } catch (error) { }
  }
  const showHistory = () => {
    history.push('/activity-logs')
  }
  return (
    <div>
      {data?.length > 0 ? (
        <List
          style={{ width: '300px', height: '300px', overflow: 'auto' }}
          bordered={false}
          dataSource={data}
          renderItem={(item) => (
            <List.Item
              key={item._id}
              style={{ flexDirection: 'column', alignItems: 'start' }}
            >
              <div
                style={{ fontWeight: item?.unread ? 'bold' : 'normal' }}
                dangerouslySetInnerHTML={{ __html: item.message }}
              />

              <Typography.Text
                type="secondary"
                title={moment(item?.createdAt).format('lll')}
              >
                {moment(item?.createdAt).fromNow()}
              </Typography.Text>
            </List.Item>
          )}
        />
      ) : (
        <Space>There are no new notifications.</Space>
      )}
      <div>
        <Space style={{ marginTop: '5px' }}>
          <Button type="link" onClick={showHistory}>
            View all
          </Button>
          {unreadCount > 0 && (
            <Button onClick={markAsRead} type="link">
              Mark all as read
            </Button>
          )}
          {data.length > 0 && (
            <Button onClick={clearAll} type="link">
              Clear all
            </Button>
          )}
        </Space>
      </div>
    </div>
  )
}
export const UserMenu = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('')
  const [loading, setLoading] = useState(false)
  const { currentUser } = useSelector((state) => state.auth)
  const { organizations } = useSelector((state) => state.dashboard)
  const [item, setItem] = useState({})
  const logout = async () => {
    clearStorage(constants.CURRENT_USER_STORAGE)
     // Determine the URL to redirect to after logout
    const signOutUrl = `${process.env.REACT_APP_HOST_PATH}/logout`; // Or whichever URL you configured in Cognito's Allowed Sign-Out URLs

    try {
        await Auth.signOut({
            // --- FIX IS HERE ---
            global: true, // Optional: Sign out from all devices
            redirectUri: signOutUrl // CRITICAL: Tells Cognito where to send the user
            // --- END OF FIX ---
        });
        // After successful logout from Cognito, manually redirect to the login page if needed
        history.push('/login'); 
    } catch (error) {
        console.error("Logout failed:", error);
    }
    // await Auth.signOut()
    window.location.href = '/login'
  }
  const [data, setData] = useState([])
  const [unreadCount, setUnreadCount] = useState(0)
  const [badgePulse, setBadgePulse] = useState(false)
  const hasInitialised = useRef(false)
  const getLogs = async () => {
    try {
      const logs = await getActivityLogs({
        cleared: false,
        sortOrder: -1,
        sortBy: 'createdAt',
      })
      const count = logs?.result?.data?.filter((item) => item?.unread)?.length
      setData(logs?.result?.data)
      setUnreadCount(count)
      if (!hasInitialised.current) {
        hasInitialised.current = true
        if (count > 0) {
          setBadgePulse(true)
          setTimeout(() => setBadgePulse(false), 1800)
        }
      }
    } catch (error) { }
  }
  useEffect(() => {
    getLogs()
    const timeout = setInterval(() => {
      getLogs()
    }, 1000 * 30)
    return () => clearInterval(timeout)
  }, [])

  const switchView = async () => {
    try {
      await updateCurrentUser({
        isHostView: !currentUser?.isHostView,
      })
      window.location.href = currentUser?.isHostView
        ? '/dashboard/organizations'
        : '/dashboard/host-organizations'
    } catch (err) { }
  }
  const menuItems = [
    // {
    //   key: 'create_organization',
    //   label: <PlusCircleOutlined style={{ fontSize: '18px', color: "#1315175C" }} />,
    //   children: [
    //     {
    //       key: 'new-organization',
    //       label: 'Create organization',
    //       onClick: () => {
    //         setType('organization')
    //         setOpen(true)
    //         setItem({})
    //       },
    //     },
    //     {
    //       key: 'new-project',
    //       label: 'Create event',
    //       onClick: () => {
    //         dispatch(loadOrganizations())
    //         setType('project')
    //         setOpen(true)
    //         setItem({})
    //       },
    //     },
    //   ],
    // },
    {
      key: 'notifications',
      label: (
        <Popover
          content={
            <NotificationList
              data={data}
              unreadCount={unreadCount}
              getLogs={getLogs}
            />
          }
          title="Notifications"
          placement="topRight"
          showArrow={false}
        >
          <Badge count={unreadCount} className={badgePulse ? 'notification-badge-pulse' : ''}>
            {svgImage.notificationHeader}
          </Badge>
        </Popover>
      ),
    },
    {
      key: 'header-user-profile',
      label: <ProfilePicture user={currentUser} size={30} />,
      children: [
        {
          key: '/profile/me',
          label: <Link to={'/profile/me'} className="dropdown-menu-item"><UserOutlined />Profile</Link>,
        },
        {
          key: '/settings',
          label: <Link to={'/settings'} className="dropdown-menu-item"><SettingOutlined />Account</Link>,
        },
        {
          key: '/messages',
          label: <Link to={'/messages'} className="dropdown-menu-item"><InboxOutlined />Inbox</Link>,
        },
        {
          key: '/messages/support',
          label: <Link to={'/messages/support'} className="dropdown-menu-item"><CustomerServiceOutlined />Support</Link>,
        },
        {
          type: 'divider',
        },
        {
          key: 'logout',
          onClick: logout,
          label: <span className="dropdown-menu-item"><LogoutOutlined />Logout</span>,
        },
        // {
        //   type: 'divider',
        // },
        // {
        //   key: 'switch',
        //   label: currentUser?.isHostView
        //     ? 'Switch to Guest view'
        //     : 'Switch to Host view',
        //   onClick: () => {
        //     switchView()
        //   },
        // },
      ],
    },
  ]

  const projectFormItems = () => {
    return (
      <>
        <Form.Item
          label="Event name"
          name="name"
          rules={[{ required: true, message: 'Event name is required' }]}
        >
          <Input placeholder="Event name" />
        </Form.Item>
        <Form.Item
          label="Organization"
          name="organizationId"
          rules={[{ required: true, message: 'Organization name is required' }]}
        >
          <Select placeholder="Select organization">
            {organizations &&
              organizations?.map((o) => {
                return (
                  <Select.Option key={o.organizationId}>{o.name}</Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </>
    )
  }
  const organizationFormItems = () => {
    return (
      <Form.Item
        label="Organization name"
        name="name"
        rules={[{ required: true, message: 'Organization name is required' }]}
      >
        <Input placeholder="Organization name" />
      </Form.Item>
    )
  }

  const onSubmit = async (values) => {
    try {
      setLoading(true)
      if (type == 'organization') {
        const res = await APIS.createOrganization(values)
        setOpen(false)
        history.push(`/dashboard/host-organizations/${res?.result?._id}`)
      } else {
        const res = await APIS.createProject(values)
        setOpen(false)
        history.push(`/dashboard/active-events/${res?.result?._id}`)
      }
    } catch (err) {
      common.errorToast(err.response?.data?.result?.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='header-right-content'>
        <div className='time'>{moment().format("h:mm A")}</div>

        <Menu
          selectedKeys={[location.pathname]}
          mode="horizontal"
          className="user-menu-header"
          triggerSubMenuAction="click"
          items={menuItems}
        />
        <ModalConfirm
          title={
            type == 'organization'
              ? 'Create new organization'
              : `Create new event`
          }
          width={700}
          okText={
            type == 'organization' ? 'Create organization' : 'Create event'
          }
          visible={open}
          loading={loading}
          formItems={
            type == 'organization' ? organizationFormItems : projectFormItems
          }
          initialValues={item}
          onSubmit={onSubmit}
          onChangeForm={(val) => {
            setItem({ ...item, ...val })
          }}
          onCancel={() => setOpen(false)}
        />
      </div>
    </>
  )
}
